import { useContext } from 'react';
import Modal from '../../../../../commons/Modal/Modal';
import { ModalProps } from '../../../../../commons/Modal/Modal.types';
import { DashboardResultsContext } from '../DashboardResults.context';
import Calendar from 'react-calendar';

export default (props: ModalProps) => {
  const { currentDates, setCurrentDates, setDateModalOpen } = useContext(DashboardResultsContext);

  const onDateChange = ([start, end]: Date[]) => {
    setCurrentDates([start, end]);
    setDateModalOpen(false);
  };

  return (
    <Modal closeOnClickOutside {...props}>
      <Calendar
        // @ts-ignore
        value={currentDates as Date[]}
        // @ts-ignore
        onChange={onDateChange}
        className={'react-calendar--centered'}
        selectRange
      />
    </Modal>
  );
};
